
// ============================================================
// WHATS_NEW_v1 -- Update-Popup nach jedem Deploy
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// STATUS: HALB-FERTIG — NICHT in App() verdrahtet, NICHT gerendert.
// Component-Definition + PRODUCT_UPDATES Konstante existieren als Dead-Code.
//
// Fortsetzungs-Plan (nächste Session):
//   1. In App() State hinzufügen:
//        const [unseenUpdates, setUnseenUpdates] = useState([]);
//      VOR der `if (!currentUser) return <LoginScreen>` Zeile (Hooks-Order!).
//   2. useEffect der bei currentUser-Wechsel localStorage prüft + unseenUpdates setzt.
//   3. dismissUpdates() Funktion die alle IDs in localStorage als gesehen markiert.
//   4. <WhatsNewModal updates={unseenUpdates} onDismiss={dismissUpdates} />
//      im JSX direkt neben <SpotlightSearch />.
//   5. Backend-Toggle: Code-Skelett liegt in server.py als WhatsNewToggleHandler
//      + Route /api/system/whats-new-toggle, NICHT deployed. Vor Deploy: GET-Endpoint
//      in Frontend einbauen damit Modal nur erscheint wenn enabled=true. Plus Admin-UI
//      mit Toggle-Schalter (z.B. in Settings oder Admin-Dashboard).
//
// BUG-HINTERGRUND (warum 2x Blackscreen):
//   In den body-Strings hatte ich gemischte Quotes: typografisches „ + ASCII " .
//   Das ASCII " schließt den JS-String vorzeitig -> Babel-Compile-Fehler -> leere Seite.
//   REGEL FÜR NÄCHSTE BAU-RUNDE: in body-Strings KEINE typografischen Quotes ineinander.
//   Stattdessen: 'single quotes' innerhalb double-quote-strings (sicher), oder backticks `...`.
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// WICHTIG: Innerhalb body-Strings KEINE typografischen Quotes - nur ASCII-' (single)
// ============================================================
export const PRODUCT_UPDATES = [
  {
    id: "2026-05-20-time-tracking",
    date: "20.05.2026",
    title: "Zeiterfassung für dein Team",
    body: "Komme/Gehe-Stempeluhr für dich und alle Mitarbeiter. Findest du in der Sidebar unter Zeiterfassung. Gesetzlich Pflicht seit 2022."
  },
  {
    id: "2026-05-20-spotlight",
    date: "20.05.2026",
    title: "Blitz-Suche überall",
    body: "Drücke Cmd+K (Mac) oder Strg+K (Windows) oder das Lupen-Symbol oben rechts um sofort Kunden, Termine, Mitarbeiter oder Services zu finden."
  },
  {
    id: "2026-05-19-assistant",
    date: "19.05.2026",
    title: "Assistenz beim Termin",
    body: "Beim Termin anlegen kannst du jetzt eine Assistenz (z.B. Lehrling) für X Minuten zuteilen. Der Helfer wird parallel als belegt markiert."
  },
  {
    id: "2026-05-19-online-booking-schutz",
    date: "19.05.2026",
    title: "Online-Buchung sicherer",
    body: "An Feiertagen und an euren freien Tagen kann niemand mehr Online-Termine buchen. Doppel-SMS bei manuellen Buchungen sind ausgeschlossen."
  },
  {
    id: "2026-05-19-phases",
    date: "19.05.2026",
    title: "Termine mit Phasen",
    body: "Strähnen, Coloration und Co. werden jetzt als getrennte Karten im Kalender gezeigt. Während der Einwirkzeit kannst du parallel andere Kunden bedienen."
  },
];

// APP_VERSION_v1 -- Versionsnummer an PRODUCT_UPDATES gekoppelt (Toby-Entscheidung 14.07.2026:
// Start mit V1.4). Regel: jeder neue "Was ist neu"-Eintrag = Minor-Bump (V1.5, V1.6, ...);
// reine Bugfixes OHNE Eintrag bumpen nicht; bei einem Major-Meilenstein Basis unten anpassen.
// Aktuell 5 Einträge -> "V1." + (5 - 1) = V1.4. Angezeigt im Sidebar-Footer.
export const APP_VERSION = "V1." + (PRODUCT_UPDATES.length - 1);
